import { render, staticRenderFns } from "./DialogRemove.vue?vue&type=template&id=1f42910a&scoped=true"
import script from "./DialogRemove.vue?vue&type=script&lang=js"
export * from "./DialogRemove.vue?vue&type=script&lang=js"
import style0 from "./DialogRemove.vue?vue&type=style&index=0&id=1f42910a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42910a",
  null
  
)

export default component.exports